import { createRequestTypes, actionCreator, getErrorMessage } from "../utils/helpers";
import { httpPostAndDispatchAction, httpGetAndDispatchAction } from "./_utils";
import axiosInstance from "../utils/axios-instance";

export const CREATE_STRIPE_CONNECT_ACCOUNT = createRequestTypes("CREATE_STRIPE_CONNECT_ACCOUNT");
export const CHECK_STRIPE_CONNECT_STATUS = createRequestTypes("CHECK_STRIPE_CONNECT_STATUS");
export const RESEND_STRIPE_CONNECT_LINK = createRequestTypes("RESEND_STRIPE_CONNECT_LINK");

/**
 * Create Stripe Connect account and send onboarding link
 * @param {string} email - Email address for the connect account
 * @param {number} systemUserId - System User ID
 * @returns Promise<Response>
 */
export const createStripeConnectAccount = (email, systemUserId) => async (dispatch) => {
  dispatch(actionCreator.request(CREATE_STRIPE_CONNECT_ACCOUNT));

  try {
    const response = await axiosInstance.post(
      `/payment-provider/stripe/connect/create?email=${encodeURIComponent(email)}&systemUserId=${systemUserId}`
    );
    dispatch(actionCreator.success(CREATE_STRIPE_CONNECT_ACCOUNT, response.data));
    return response;
  } catch (err) {
    const mockError = getErrorMessage(err);
    dispatch(actionCreator.failure(CREATE_STRIPE_CONNECT_ACCOUNT, mockError));
    throw err;
  }
};

/**
 * Check Stripe Connect account onboarding status
 * @param {string} stripeConnectAccountId - Stripe Connect account ID (from payment.provider.stripe.connect.account.id)
 * @returns Promise<Response>
 */
export const checkStripeConnectStatus = (stripeConnectAccountId) =>
  httpGetAndDispatchAction(
    CHECK_STRIPE_CONNECT_STATUS,
    `/payment-provider/stripe/connect/status/account/${stripeConnectAccountId}`
  );

/**
 * Resend Stripe Connect onboarding link
 * @param {string} email - Email address for the connect account
 * @param {number} systemUserId - System User ID
 * @returns Promise<Response>
 */
export const resendStripeConnectLink = (email, systemUserId) => async (dispatch) => {
  dispatch(actionCreator.request(RESEND_STRIPE_CONNECT_LINK));

  try {
    const response = await axiosInstance.post(
      `/payment-provider/stripe/connect/resend-link?email=${encodeURIComponent(email)}&systemUserId=${systemUserId}`
    );
    dispatch(actionCreator.success(RESEND_STRIPE_CONNECT_LINK, response.data));
    return response;
  } catch (err) {
    const mockError = getErrorMessage(err);
    dispatch(actionCreator.failure(RESEND_STRIPE_CONNECT_LINK, mockError));
    throw err;
  }
};
